import * as FormElementModal from './form-element.modal';

export interface InputElement {
  inputElements:
    | FormElementModal.Datepicker
    | FormElementModal.NumberInput
    | FormElementModal.PrimaryButton
    | FormElementModal.RadioButton
    | FormElementModal.SelectList
    | FormElementModal.TextInput
    | FormElementModal.Checkbox
    | FormElementModal.TextArea
    | FormElementModal.RadioSwitch;
}

export interface inputElementListItem {
  parent: string;
  inputs: InputElement[];
}

export interface inputElementList {
  inputElementList: inputElementListItem;
}

export interface FormMap {
  formMap: inputElementList;
}

export interface FormGenerator {
  forms: FormMap;
}
